const withRenderedMain = require('components-framework/view/with_rendered_main');

const processTemplateData = ({keys, options}) => ({
    keys: Odigeo._.extend(keys, {
        loginRememberMePassengersWellComeBack: Odigeo.Utils.replaceCmsKeyArgs(keys.loginRememberMePassengersWellComeBack, options.userName),
    }),
    options,
});

module.exports = withRenderedMain(Backbone.View, processTemplateData);
